import * as THREE from 'three'

import shaderFragment from '../../shaders/areaFence/fragment.glsl'
import shaderVertex from '../../shaders/areaFence/vertex.glsl'

/**
 * 创建一个具有指定属性的着色材质，并返回创建的材质对象。
 */
export default function()
{
    const uniforms = {
        uTime: { value: null },
        uBorderAlpha: { value: null },
        uStrikeAlpha: { value: null }
    }

    /**
     * wireframe：设置为false，表示不以线框模式渲染材质。
     * transparent：设置为true，表示材质是透明的。
     * side：设置为THREE.DoubleSide，表示材质将被渲染到物体的前面和后面。
     * depthTest：设置为true，表示启用深度测试，以确定渲染对象的可见性。
     * depthWrite：设置为false，表示不写入深度缓冲区。
     * uniforms：引用了之前定义的uniforms对象，用于传递给着色器程序。
     * vertexShader和fragmentShader：分别引用了名为shaderVertex和shaderFragment的着色器代码，用于定义材质的顶点着色器和片元着色器。
     */
    const material = new THREE.ShaderMaterial({
        wireframe: false,
        transparent: true,
        side: THREE.DoubleSide,
        depthTest: true,
        depthWrite: false,
        uniforms,
        vertexShader: shaderVertex,
        fragmentShader: shaderFragment
    })

    return material
}
